
import { AirroadJobDetailed } from '@/models/airRoad';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { downloadAirRoadJobsPDF } from '@/api';
import { notificationErrorText, jobItemsTypes, arJobStatuses } from '@/utils/PortalConstants';
import { getARServiceData } from '@/utils/Common';

import Icon from '@/components/UI/Icon.vue';
import StopDrawing from '@/components/jobDetailed/StopDrawing/StopDrawing.vue';
import Tooltip from '@/components/UI/Tooltip.vue';
import PrintActionBtn from '@/components/btns/PrintActionBtn.vue';

@Component({
  components: {
    Icon,
    StopDrawing,
    Tooltip,
    PrintActionBtn,
  },
})
export default class AirRoadJobsDetailed extends Vue {
  @Prop({ type: Array, required: true }) public readonly arJobs!: AirroadJobDetailed[];

  private getARServiceData = getARServiceData;

  public loading = false;
  public loadingPdf = false;

  // AirRoad constants
  public arJobItemsTypes = jobItemsTypes;
  public arJobStatuses = arJobStatuses;

  public tableOpenedJobIdx = -1;

  // TABLE ROW CLICK
  public tableJobRowClick(idx) {
    if (this.tableOpenedJobIdx === idx) {
      this.tableOpenedJobIdx = -1;
    } else {
      this.tableOpenedJobIdx = idx;
    }
  }

  /**
   * Expand vuetify-data-table if data has a single job
   * @private
   */
  private expandIfSingleJob() {
    if (this.arJobs.length === 1) {
      this.tableOpenedJobIdx = 0;
    }
  }

  /**
   * Downloads generated PDF from the server.
   * @param id list of AR job IDs.
   * @param connote connote, used to name a PDF file
   * @public
   */
  public downloadLabel(id: number, connote: string) {
    this.loadingPdf = true;
    downloadAirRoadJobsPDF([id])
      .then(res => {
        const blob = new Blob([res.data], { type: 'pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${connote}_labels.pdf`;
        link.click();
        URL.revokeObjectURL(link.href);
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'Error downloading labels',
          text: notificationErrorText,
          type: 'warn',
        });
      })
      .finally(() => {
        this.loadingPdf = false;
      });
  }

  private mounted() {
    this.expandIfSingleJob();
  }
}
